"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_use_1 = require("react-use");
const luxon_1 = require("luxon");
const mui_1 = require("tss-react/mui");
const core_1 = require("companion-app-components/utils/core");
const accountsSelectors_1 = require("companion-app-components/flux/accounts/accountsSelectors");
const accountsUtils_1 = require("companion-app-components/flux/accounts/accountsUtils");
const selectors_1 = require("data/accountBalances/selectors");
const selectors_2 = require("data/reconcileList/selectors");
const useQDialogs_1 = __importDefault(require("components/QDialogs/useQDialogs"));
const styles_1 = require("./styles");
const ReconcileSetup_1 = __importDefault(require("./ReconcileSetup"));
const ReconcileWorkspace_1 = __importDefault(require("./ReconcileWorkspace"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
/**
 * Presents the form to bulk edit a group of transactions
 */
const ReconcilePanel = (props) => {
    const { dialogAlert } = (0, useQDialogs_1.default)();
    const { classes } = useStyles();
    const [state, setState] = (0, react_1.useState)({
        statementEndDate: null,
        statementEndBalance: null,
        showSetup: true,
        useOnline: false,
    });
    const accountBalances = (0, react_redux_1.useSelector)((rootState) => (0, selectors_1.getBalancesByAccountId)(rootState).get(props.accountId));
    const accountRecord = (0, react_redux_1.useSelector)((rootState) => (0, accountsSelectors_1.getAccountsById)(rootState).get(props.accountId));
    const reconcileInfo = (0, react_redux_1.useSelector)((rootState) => (0, selectors_2.getReconcileInfoForAccount)(rootState, {
        accountId: props.accountId,
        statementDate: (0, accountsUtils_1.isActiveConnectedAccountFromId)(props.accountId, rootState) ? null : luxon_1.DateTime.now().toFormat('yyyy-MM-dd'),
        statementEndingBalance: 0,
    }));
    const closeAndExit = (status) => {
        if (status && status !== 'canceled') {
            core_1.tracker.track(core_1.tracker.events.reconcileAnAccount, {
                method: state.useOnline ? 'Online Balance' : 'Paper Statement',
                status,
            });
        }
        props.onClose();
    };
    const onSave = (data) => {
        core_1.tracker.track(core_1.tracker.events.reconcileAnAccount, {
            method: data.useOnline ? 'Online Balance' : 'Paper Statement',
            status: 'Started',
        });
        setState({
            useOnline: data.useOnline,
            showSetup: false,
            statementEndDate: data.statementEndDate,
            statementEndBalance: data.statementEndBalance,
        });
    };
    (0, react_use_1.useEffectOnce)(() => {
        if (!reconcileInfo) {
            closeAndExit();
        }
    });
    if (!reconcileInfo) {
        dialogAlert('There are no transactions to reconcile', '', null, ['Got It'], 'info');
        return null;
    }
    return (<>
      {state.showSetup &&
            <ReconcileSetup_1.default accountBalances={accountBalances} 
            // @ts-expect-error - FIXME: Type 'undefined' is not assignable to type 'Account'
            account={accountRecord} 
            // @ts-expect-error TS(2554) - FIXME: Expected 2 arguments, but got 1
            isOnline={(0, accountsUtils_1.isActiveConnectedAccountFromId)(props.accountId)} lastReconciledBalance={reconcileInfo.get('registerReconciledBalance')} onSave={onSave} onClose={closeAndExit} classes={classes}/>}
      {!state.showSetup &&
            <ReconcileWorkspace_1.default 
            // @ts-expect-error - FIXME: Type 'undefined' is not assignable to type 'Account'
            account={accountRecord} statementEndDate={state.statementEndDate} statementEndBalance={Number(state.statementEndBalance)} onClose={closeAndExit} classes={classes}/>}
    </>);
};
exports.default = (0, react_1.memo)(ReconcilePanel);
